import { render, staticRenderFns } from "./JoinedMatch.vue?vue&type=template&id=977b2d90&scoped=true&"
import script from "./JoinedMatch.vue?vue&type=script&lang=js&"
export * from "./JoinedMatch.vue?vue&type=script&lang=js&"
import style0 from "./JoinedMatch.vue?vue&type=style&index=0&id=977b2d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977b2d90",
  null
  
)

export default component.exports